import { type GetChatroomsQueryParams, useGetChatrooms } from '@pba/react-chat-core';
import { createChatroom } from 'models';
import { useMemo } from 'react';

export const useChatroomsInfiniteQuery = ({ filter, options, pagination }: GetChatroomsQueryParams) => {
  const query = useGetChatrooms({
    filter,
    options,
    pagination,
  });

  const data = useMemo(
    () =>
      query.data?.pages
        .flat()
        .filter((chatroom) => chatroom !== null)
        .map((chatroom) => createChatroom(chatroom)),
    [query.data?.pages],
  );

  return useMemo(
    () => ({
      ...query,
      data,
    }),
    [data, query],
  );
};
